import { Outlet } from 'react-router'
import { useSyncSentryUser } from 'src/service/utils/sentry/syncUser'

const Layout = () => {
  useSyncSentryUser()

  return (
    <>
      <Outlet />
    </>
  )
}

export default Layout
